/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { projectTypeGridConfig } from "./features/config/ProjectType.data";
import PropTypes from "prop-types";

/** Common Components */
import MolGrid from "../../../components/grid/MolGrid";
import CenterModel from "../../../components/ui/centerModel/CenterModel";
import CardSection from "../../../components/ui/card/CardSection";

/** RTK Query */
import { useDeleteProjectTypeMutation, useGetAllProjectTypesMutation } from "../../../app/services/projectTypeAPI";

/** Common Services & Data Files */
import ToastService from "../../../services/toastService/ToastService";
import SwalAlert from "../../../services/swalService/SwalService";

/** Custom Hooks */
import useDebounce from "../../../app/customHooks/useDebounce";

import AddEditType from "./features/AddEditType";

const ProjectType = (props) => {

  const molGridRef = useRef();
  const { confirm } = SwalAlert();

  const [dataSource, setDataSource] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);

  const [searchText, setSearchText] = useState("");
  const debouncedSearch = useDebounce(searchText, 300);
    
  const [showModal, setShowModal] = useState(false);
  const [projectTypeId, setProjectTypeId] = useState(null);

  const handleOnSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  //** API Call's */
  const [getAllProjectTypes, {
    isFetching: isListLoading,
    isSuccess: isListSuccess,
    data: listResponse },] = useGetAllProjectTypesMutation();

  const [deleteProjectType, {
    isSuccess: isDeleteSuccess,
    isLoading: isDeleteLoading,
    data: isDeletData
  },] = useDeleteProjectTypeMutation();

  //** Funcation's */
  const getProjectTypeList = (pageObject) => {
    const request = {
      pagination: { pageNumber: pageObject.pageNumber, pageSize: pageObject.pageSize },
      filters: { searchText: debouncedSearch },
    };
    getAllProjectTypes(request);
  };

  const handlePageChange = (page) => {
    getProjectTypeList(page);
  };

  const onEditAction = (data) => {
    setProjectTypeId(data.projectTypeId)
    setShowModal(true);
  };
  
  const handleDeleteClick = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to delete this Project Type?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteProjectType(data.projectTypeId);
      }
    });
  };

  const handleProjectTypeModal = () => {
    setProjectTypeId(null);
    setShowModal(!showModal);
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: props.search },
      };
      getProjectTypeList(request.pagination);
    }
  };

  //** Use Effects */
  useEffect(() => {
    if (isListSuccess && listResponse) {
      setDataSource(listResponse?.dataSource || []);
      setTotalRowCount(listResponse?.totalRecord || 0);
    }
  }, [isListSuccess, listResponse]);

  useEffect(() => {
    if (isDeleteSuccess && isDeletData) {
      ToastService.success(isDeletData.errorMessage);
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      getProjectTypeList(currentPageObject);
    }
  }, [isDeleteSuccess, isDeletData]);

  useEffect(() => {
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      getProjectTypeList(currentPageObject);
    }
  }, [debouncedSearch]);

  //** Action Handler */
  const actionHandler = {
    DELETE: handleDeleteClick,
    EDIT: onEditAction,
  };

  return (
    <>
      <div className="project-domain-list center-top-space">
        <CardSection
          isContentLoading={isListLoading}
          cardTitle={"Project Type List"}
          rightButton={true}
          titleButtonClick={handleProjectTypeModal}
          buttonClassName="theme-btn"
          textWithIcon={true}
          iconName="material-symbols:add-rounded"
          fontIcon={true}
          buttonText="Add Project Type"
          searchInputName="Search by Project Type"
          searchInput={true}
          handleChange={handleOnSearchChange}
        >
          <div className="table-grid">
            <MolGrid
              ref={molGridRef}
              configuration={projectTypeGridConfig}
              dataSource={dataSource}
              allowPagination={true}
              pagination={{
                totalCount: totalRowCount,
                pageSize: 20,
                currentPage: 1,
              }}
              isLoading={isListLoading || isDeleteLoading}
              onActionChange={actionHandler}
              onPageChange={handlePageChange}
            />
          </div>
        </CardSection>
      </div>
      <div>
        {showModal && (
          <CenterModel
            showModal={showModal}
            handleToggleModal={handleProjectTypeModal}
            modalTitle={projectTypeId ? "Update Project Type" : "Add Project Type"}
            modelSizeClass="w-40"
          >
            <div className="row">
              <AddEditType
                onClose={handleProjectTypeModal}
                projectTypeId={projectTypeId}
              />
            </div>
          </CenterModel>
        )}
      </div>
    </>
  );
};

ProjectType.propTypes = {
  search: PropTypes.string,
};
export default ProjectType;